import cn from 'classnames'
import styles from './PlaceABid.module.sass'
import React, { useContext, useState } from 'react'
import { Web3Context } from '../../contexts/Web3Context'
import Modal from '../Modal'
import Icon from '../Icon'
import Connect from '../Connect'
import Bid from '../Bid'
import SwitchNetwork from '../ConnectMetamask/SwitchNetwork'

const PlaceABid = ({ item, users }) => {
  const { isConnected, defaultAccount, isCorrectNetwork } = useContext(Web3Context)

  const [visibleModalBid, setVisibleModalBid] = useState(false)

  return (
    <>
      {defaultAccount !== item.currentOwner &&
        <button
          className={cn('button', styles.button)}
          onClick={() => setVisibleModalBid(true)}
        >
          <span>Buy</span>
          <Icon name="scatter-up" size="16"/>
        </button>}

      <Modal
        visible={visibleModalBid}
        onClose={() => setVisibleModalBid(false)}
        onClickOutside={() => null}
      >
        {!isConnected && <Connect/>}

        {isConnected && isCorrectNetwork && <Bid
          token={item}
          users={users}
          onOutsideClick={() => setVisibleModalBid(false)}
        />}

        {isConnected && !isCorrectNetwork && <SwitchNetwork/>}
      </Modal>
    </>
  )
}

export default PlaceABid